// Historial de llamadas de la web, como la pestaña Recientes de la app Android.
// Se guarda solo en este navegador (localStorage); si no hay almacenamiento, la
// lista vive mientras la página está abierta.

export interface RecentCall {
  number: string;
  at: number; // inicio del intento (ms)
  durationSec: number; // 0 si no llegó a conectar
  connected: boolean;
}

const KEY = "recientes";
const MAX = 100;
let memory: RecentCall[] | null = null;

export function loadRecents(): RecentCall[] {
  if (memory) return memory;
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) ?? "[]");
    memory = Array.isArray(raw)
      ? raw.filter((r) => typeof r?.number === "string" && typeof r?.at === "number").slice(0, MAX)
      : [];
  } catch {
    memory = [];
  }
  return memory;
}

function save(list: RecentCall[]) {
  memory = list;
  try { localStorage.setItem(KEY, JSON.stringify(list)); } catch { /* sin almacenamiento */ }
}

export function addRecent(call: RecentCall) {
  save([call, ...loadRecents()].slice(0, MAX));
}

export function clearRecents() {
  save([]);
}

/** «Hoy 12:31», «Ayer 18:05» o «14/10 09:20». */
export function whenText(at: number): string {
  const d = new Date(at);
  const hour = d.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" });
  const day = (x: Date) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const diff = Math.round((day(new Date()) - day(d)) / 86_400_000);
  if (diff === 0) return `Hoy ${hour}`;
  if (diff === 1) return `Ayer ${hour}`;
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")} ${hour}`;
}

export function durationText(sec: number): string {
  return `${Math.floor(sec / 60)}:${String(sec % 60).padStart(2, "0")}`;
}
